import MasterAdmin from "@api/masteradmin/masteradmin";

export const masterAdminApi = new MasterAdmin();
